<template>
  <main>
    <div class="d-flex flex-wrap flex-row my-4">
      <h1 class="h3 mr-5">
        {{ $t("c-planning-title") }}
      </h1>
      <div>
        <b-button
          v-if="showAgencyDiscussion"
          @click="goToDiscussion('agency')"
          class="mr-5 mb-2"
          variant="primary"
        >
          {{ $t("discuss-agency-btn") }}
        </b-button>
        <b-button
          v-if="showAdvTeamDiscussion"
          @click="goToDiscussion('adv')"
          class="mb-2"
          variant="primary"
        >
          {{ $t("discuss-team-btn") }}
        </b-button>
      </div>
    </div>
    <section class="mb-4">
      <section class="mb-4">
        <div class="row">
          <div class="col-lg-12">
            <b-card class="mb-3 shadow">
              {{ $t("planning-page-planning-description") }}
            </b-card>
          </div>
        </div>
      </section>
      <full-calendar
        v-if="!hasError && !isLoading"
        :options="calendarOptions"
      ></full-calendar>
      <!-- Button group -->
      <b-row class="button-group mt-4" v-if="isDevelopment">
        <b-col col lg="3">
          <b-button
            to="/planning/add-intervention"
            class="nowrap mb-2"
            variant="primary"
          >
            {{ $t("planning-add-intervention") }}
          </b-button>
        </b-col>
        <b-col col lg="3">
          <b-button
            class="nowrap"
            to="/planning/request-list"
            variant="primary"
            >{{ $t("planning-request-list") }}</b-button
          >
        </b-col>
      </b-row>
    </section>
    <section class="mb-4">
      <vita-telegestion
        :sectionTitle="$t('planning-page-remote-management-title')"
      ></vita-telegestion>
    </section>

    <!-- POINTAGE HISTORY -->
    <section class="pb-4">
      <h1 class="h3 mb-3">
        {{ $t("planning-history-pointage") }}
      </h1>
      <b-overlay rounded="sm">
        <b-card class="mb-4 shadow bg-white rounded">
          <div class="row">
            <div
              v-for="pointing in getDisplayList()"
              :key="pointing.pkHorodatage"
              class="col-md-12 col-sm-12 col-xs-12"
            >
              <!--<div class="d-flex justify-content-center mb-3">-->
              <!--<div class=" text-left">-->
              <b-row class="mb-3 justify-content-md-center">
                <b-col md="auto" sm="2">
                  <b-img
                    v-if="pointing.isVitaphone"
                    :src="require('../../../assets/phone.png')"
                    :width="25"
                    :height="25"
                    fluid
                    alt="Tel"
                    class="mr-3"
                  />
                  <b-img
                    v-else
                    :src="require('../../../assets/barcode-qr@3x.png')"
                    :width="25"
                    :height="25"
                    fluid
                    alt="QRCode"
                    class="mr-3"
                  />
                </b-col>
                <b-col
                  class="pointage-type"
                  col
                  lg="1"
                  md="1"
                  sm="3"
                  v-if="pointing.typePointage === 1"
                >
                  <b class="mr-3 custom-label-check">
                    {{ $t("history-pointage-checkin-label") }}
                  </b>
                </b-col>
                <b-col col lg="1" md="1" sm="3" v-else>
                  <b class="mr-3 custom-label-check">
                    {{ $t("history-pointage-checkout-label") }}
                  </b>
                </b-col>
                <b-col md="auto" lg="2" sm="3" class="point-name">{{
                  pointing.advName
                }}</b-col>
                <b-col md="auto" sm="2">{{
                  pointing.horodatage | formatDateY
                }}</b-col>
                <b-col md="auto" sm="2">{{
                  pointing.horodatage | formatUnixMinuteHour
                }}</b-col>
              </b-row>
              <!--</div>-->
              <!--</div>-->
            </div>
          </div>
        </b-card>
        <b-pagination
          class="mx-auto pagination"
          v-model="pointCurrentPage"
          :total-rows="listPointing.length"
          :per-page="pointPerPage"
        ></b-pagination>
      </b-overlay>
    </section>
  </main>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import frLocale from "@fullcalendar/core/locales/fr";
import interactionPlugin from "@fullcalendar/interaction";

import VitaTelegestion from "../../Documents/Telegestion/Telegestion.vue";
import { mapActions, mapGetters } from "vuex";
import activation from "../../Mixins/activation";

var moment = require("moment");
const nodeEnv =
  window.configs && window.configs.NODE_ENV !== ""
    ? window.configs.NODE_ENV
    : process.env.NODE_ENV;
export default {
  components: {
    FullCalendar,
    VitaTelegestion
  },
  mixins: [activation],
  data() {
    return {
      moment: moment,
      isLoading: true,
      hasError: false,
      // TODO: Afficher les tooltips ou les popovers contenantes la description de l'evenement qui contient en lui même les coordonnées de l'ADV sauf qu'ils n'existent pas sur cet objet evenement
      // eventRender: function(event, element){
      //   console.log("gdqsfkqsùm")
      //       // element.popover({
      //       //     animation:true,
      //       //     delay: 300,
      //       //     content: '<b>Inicio</b>:'+event.start+"<b>Fin</b>:"+event.end,
      //       //     trigger: 'hover'
      //       // });
      //       var att = document.createAttribute("id");       // Create a "class" attribute
      //       att.value = "987654321";                           // Set the value of the class attribute
      //       element.setAttributeNode(att);
      //     },
      calendarOptions: {
        events: [],
        plugins: [timeGridPlugin, dayGridPlugin, listPlugin, interactionPlugin],
        eventClick: this.eventSelect,
        initialView: "timeGridWeek",
        locales: frLocale,
        locale: "fr",
        headerToolbar: { center: "dayGridMonth,timeGridWeek,listWeek" },
        firstDay: 1
      },
      eventsColors: [
        "#800080",
        "#696969",
        "#8b4513",
        "#2e8b57",
        "#006400",
        "#8b0000",
        "#808000",
        "#483d8b",
        "#008080",
        "#4682b4",
        "#000080",
        "#b03060",
        "#ff4500",
        "#8a2be2",
        "#dc143c",
        "#0000ff",
        "#ff00ff",
        "#1e90ff",
        "#ff1493"
      ],
      pointCurrentPage: 1,
      pointPerPage: 10,
      listPointing: []
    };
  },
  created() {
    this.load();
  },
  computed: {
    ...mapGetters("interventions", ["allData", "dataError", "storeData"]),
    ...mapGetters("telegestion", ["history", "storedPage"]),

    isDevelopment() {
      return nodeEnv === "development";
    }
  },
  watch: {
    storeData(newData) {
      this.addToCalendar(newData);
    },

    dataError() {
      this.hasError = true;
      this.isLoading = false;
    },

    history() {
      this.listPointing = this.history;
    }
  },
  methods: {
    ...mapActions("interventions", ["loadInterventions"]),
    ...mapActions("telegestion", ["getPointageHistory"]),
    load() {
      if (this.storeData) {
        this.addToCalendar(this.storeData);
      } else {
        const data = {
          debut: null,
          fin: null
        };
        this.loadInterventions(data);
      }

      if (this.history.length) {
        this.listPointing = this.history;
      } else {
        this.loadPointHistory();
      }
    },

    loadPointHistory() {
      const params = {
        page: this.pointCurrentPage
      };
      this.getPointageHistory(params);
    },

    addToCalendar(data) {
      const distinctAdvList = [];
      data.forEach(element => {
        if (!distinctAdvList.includes(element.pkAdv)) {
          distinctAdvList.push(element.pkAdv);
        }

        var row = {
          title: element.firstName + " " + element.lastName,
          start: moment(element.start).format("YYYY-MM-DD HH:mm:ss"),
          end: moment(element.end).format("YYYY-MM-DD HH:mm:ss"),
          color: this.eventsColors[distinctAdvList.indexOf(element.pkAdv)]
        };

        if (element.firstName == null) {
          row.title = this.$t("in-the-processing-of-being-set-up") + "...";
        }

        const ignoreUnstaffedInterventions =
          element.pkAdv == null && moment(Date.now()).isAfter(element.start);

        if (!ignoreUnstaffedInterventions) {
          this.calendarOptions.events.push(row);
        }
      });
      this.isLoading = false;
    },

    getDisplayList() {
      const startAt = (this.pointCurrentPage - 1) * this.pointPerPage;
      let endAt = startAt + this.pointPerPage;
      if (startAt + this.pointPerPage > this.listPointing.length) {
        endAt = this.listPointing.length;
      }
      return this.listPointing.slice(startAt, endAt);
    },

    eventSelect(data) {
      if (this.isDevelopment) {
        this.$router.push({
          path: "/planning/intervention",
          query: {
            start: moment(data.event.start).format("x"),
            end: moment(data.event.end).format("x")
          }
        });
      }
    },

    goToDiscussion(type) {
      this.$router.push({
        path: "/discussions",
        query: {
          type: type
        }
      });
    }
  }
};
</script>

<style>
/* @import "~@fullcalendar/core/main.css"; */
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/list/main.css";

.fc-center h2 {
  font-size: 1rem;
  line-height: 2;
}
@media (max-width: 768px) {
  .fc-toolbar {
    display: flex;
    justify-items: center;
    flex-direction: column;
    min-height: 150px;
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .fc-scrollgrid-section-liquid > td {
    height: 350px !important;
  }

  .fc-view-harness {
    min-height: 500px;
  }
}
.fc-title,
.fc-time {
  color: white;
  font-weight: 400;
}

.fc-dayGridMonth-button.fc-button-primary:not(:disabled).fc-button-active:focus,
.fc-dayGridMonth-button.fc-button-primary:not(:disabled).fc-button-active,
.fc-dayGridMonth-button.fc-button-primary:hover,
.fc-timeGridWeek-button.fc-button-primary:not(:disabled).fc-button-active:focus,
.fc-timeGridWeek-button.fc-button-primary:not(:disabled).fc-button-active,
.fc-timeGridWeek-button.fc-button-primary:hover,
.fc-listWeek-button.fc-button-primary:not(:disabled).fc-button-active:focus,
.fc-listWeek-button.fc-button-primary:not(:disabled).fc-button-active,
.fc-listWeek-button.fc-button-primary:hover {
  color: white !important;
  background-color: var(--primary) !important;
}

.fc-dayGridMonth-button.fc-button-primary,
.fc-timeGridWeek-button.fc-button-primary,
.fc-listWeek-button.fc-button-primary {
  color: var(--primary) !important;
  background-color: #fff !important;
}

.fc-button-primary:not(:disabled).fc-button-active:focus,
.fc-button-primary:not(:disabled).fc-button-active,
.fc-button-primary:hover {
  color: var(--primary) !important;
  background-color: #fff !important;
  border-color: var(--primary) !important;
}

/*The event title in Mois mode*/
.fc-daygrid-event,
.fc-daygrid-event:hover,
.fc-button-primary:focus:active,
.fc-button-primary:disabled,
.fc-button-primary {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

/* The day number in Mois mode */
.fc-daygrid-day-number {
  color: #212529;
}
/*The calendar header in Semaine mode*/
.fc-col-header-cell-cushion {
  color: #212529;
}
/* The calendar header in Planning mode */
.fc-list-day-cushion a {
  color: #212529;
}

/* Pagination */
.pagination {
  width: fit-content;
}

.point-name {
  overflow-wrap: break-word;
}

.pointage-type {
  white-space: nowrap;
}

.fc-timegrid-event,
.fc-daygrid-event-dot,
.fc-list-event-dot {
  border-color: var(--primary) !important;
  background-color: var(--primary) !important;
}

@media (max-width: 575px) {
  .point-name {
    text-align: unset;
  }
}
</style>
